// Exports
export default {
	"Popup": "Popup_oxdVq",
	"Close": "Close_1GC7l",
	"Description": "Description_TdoRe"
};
